var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ob1-cards",
    {
      staticClass: "full-height",
      attrs: {
        "data-test-id": "device-card",
        "is-link": "",
        title:
          "Découvrir " +
          _vm.currentVersion.brand +
          " " +
          _vm.currentVersion.name,
        href: _vm.currentVersion.detailLink,
        "data-oevent-category": "selecteur_produit",
        "data-oevent-action":
          "bloc_" + _vm.currentVersion.name.split(" ").join("_"),
        "data-oevent-label": _vm.currentVersion.detailLink,
      },
    },
    [
      _c(
        "div",
        { staticClass: "d-flex flex-column h-100 justify-content-between" },
        [
          _c("div", { staticClass: "selector-card-upper-part" }, [
            _c("div", { staticClass: "position-absolute" }, [
              _vm.isTagIndisponible
                ? _c(
                    "div",
                    [
                      _c("ob1-tag", {
                        attrs: {
                          type: "unavailable",
                          label: _vm.model.status.label,
                        },
                      }),
                    ],
                    1
                  )
                : _vm.currentVersion.tag
                ? _c(
                    "div",
                    [
                      _c("ob1-tag", {
                        attrs: { label: _vm.currentVersion.tag },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex flex-row pt-2 px-1" }, [
              _c("div", { staticClass: "img-mobile mx-1" }, [
                _c(
                  "div",
                  { staticClass: "img-container" },
                  [
                    _c("selector-color-chips", {
                      attrs: { colors: _vm.model.colors },
                    }),
                    _vm._v(" "),
                    _vm.currentVersion.image
                      ? _c("ob1-picture", {
                          attrs: { visual: _vm.currentVersion.image },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.currentVersion.imageOverlay
                      ? _c("ob1-simple-image", {
                          staticClass: "img-overlay",
                          attrs: {
                            visual: _vm.currentVersion.imageOverlay,
                            "css-classes": "img-network-compatibility",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "infos" }, [
                _c("div", { staticClass: "mobile-infos" }, [
                  _c(
                    "h2",
                    {
                      staticClass: "no-signature standard pb-0 my-0 fw-normal",
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.currentVersion.brand)
                      ),
                      _c("br"),
                      _vm._v(" "),
                      _c("strong", { staticClass: "standard" }, [
                        _vm._v(_vm._s(_vm.currentVersion.name)),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.currentVersion.reviews
                    ? _c(
                        "div",
                        { staticClass: "mb-1" },
                        [
                          _c("ob1-rating", {
                            attrs: {
                              average: _vm.currentVersion.reviews.average,
                              "with-score": true,
                              "rating-results-height": 1.01,
                              "font-size": 0.875,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentVersion.isRefurbished
                    ? _c(
                        "div",
                        { staticClass: "mt-1" },
                        [
                          _c("ob1-capsule", {
                            attrs: {
                              label: _vm.currentVersion.refurbishedLabel,
                              "is-context": "",
                              "is-small": "",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.model.status &&
                  _vm.model.status.label &&
                  !_vm.isTagIndisponible
                    ? _c(
                        "div",
                        { staticClass: "mt-1" },
                        [
                          _c("ob1-tag", {
                            attrs: {
                              type: "unavailable",
                              label: _vm.model.status.label,
                              "is-small": "",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _vm.currentVersion.price
                  ? _c(
                      "div",
                      { staticClass: "mt-1 infos-price" },
                      [
                        _c("ob1-prix-terminal", {
                          attrs: {
                            "multiple-price": _vm.hasMultiplePrice(
                              _vm.currentVersion.price
                            ),
                            "compact-price": true,
                            "total-price-with-promo":
                              _vm.currentVersion.price.price
                                .totalPriceWithPromo,
                            "total-price-without-promo":
                              _vm.currentVersion.price.price
                                .totalPriceWithoutPromo,
                            "order-price-label":
                              _vm.currentVersion.price.price.orderPriceLabel,
                            "is-cents-format": true,
                            "payment-info-label": _vm.currentVersion.price.price
                              .paymentInfoLabel
                              ? _vm.currentVersion.price.price.paymentInfoLabel
                                  .label
                              : null,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _vm.currentVersion.price && _vm.currentVersion.price.advantageValues
              ? _c(
                  "div",
                  { staticClass: "infos-advantage p-1" },
                  [
                    _c("advantage-bloc", {
                      attrs: {
                        "advantage-messages": _vm.advantageMessages,
                        "bonus-recovery":
                          _vm.currentVersion.price.advantageValues
                            .bonusRecovery,
                        discount:
                          _vm.currentVersion.price.advantageValues.discount,
                        odr: _vm.currentVersion.price.advantageValues.odr,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }